import { getBackgroundColor, getColor } from './_BaseBadge.theme.utils';
export var _baseBadgeTheme = {
  baseStyle: _ref => {
    var {
      status,
      type
    } = _ref;
    return {
      paddingX: 'xs',
      display: 'inline-flex',
      minWidth: '16px',
      height: '16px',
      textStyle: 'caption1',
      borderRadius: 'xl',
      whiteSpace: 'nowrap',
      backgroundColor: getBackgroundColor(status, type),
      color: getColor(status, type),
      border: type === 'status' ? 'basic.light' : 'none',
      width: 'fit-content',
      alignItems: 'center',
      justifyContent: 'center',
      _readOnly: {
        backgroundColor: type === 'primary' ? 'neutral.darker' : 'neutral.white',
        border: type === 'status' ? 'basic.light' : 'basic.darker',
        color: type === 'primary' ? 'neutral.white' : 'neutral.darker'
      },
      _disabled: {
        backgroundColor: type === 'status' ? 'neutral.white' : 'neutral.light',
        border: 'basic.light',
        color: type === 'status' ? 'neutral.light' : 'neutral.white'
      }
    };
  }
};
//# sourceMappingURL=_BaseBadge.theme.js.map